var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.crews),function(crew,index){return _c('div',{key:index,staticClass:"q-pb-sm col-md-4"},[_c('card',{attrs:{"element":crew.person,"detail":_vm.details,"person":_vm.person,"type":crew.type}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }